import { useQuery } from 'cccisd-react-query';
import { client } from 'cccisd-apollo';
import surveyHandlesQuery from './surveyHandles.graphql';

const useSurveyHandles = () => {
    // TODO: get survey handles just for SHARE project
    const { data } = useQuery({
        queryKey: ['getSurveyHandles'],
        queryFn: async () => {
            const res = await client.query({
                query: surveyHandlesQuery,
                fetchPolicy: 'network-only',
            });

            return res.data.flows.surveyList.reduce((obj, item) => {
                obj[item.surveyHandle] = item.surveyId;
                return obj;
            }, {});
        },
    });

    return {
        loading: !data,
        data,
    };
};

export default useSurveyHandles;
